<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="formObserver">
    <b-form v-if="dossierSelected" @submit.prevent="handleSubmit(send())">
      <div class="block-flat">
        <div class="header">
          <h3>Type de la demande</h3>
        </div>
        <!--        <div class="form-group">-->
        <div class="block-content">
          <div class="form-group">
            <b-row>
              <b-col xl="3" lg="3" md="3" sm="12" cols="12" class="no-padding">
                <label class="control-label"
                  >Nature des travaux <span class="red">*</span>:</label
                >
              </b-col>
              <b-col xl="9" lg="9" md="9" sm="12" cols="12">
                <ValidationProvider
                  mode="lazy"
                  v-slot="{ errors }"
                  rules="required"
                  name="nature des travaux"
                >
                  <b-form-select
                    :state="errors[0] ? false : null"
                    placeholder="Choisissez une nature"
                    v-model="natureWorkOther"
                    :options="naturesTvx"
                    @change="changeNature"
                  ></b-form-select>
                  <div class="error">{{ errors[0] }}</div>

                  <b-alert
                    v-if="
                      natureWorkOther == 'Travaux de câblage' &&
                      dossierSelected.type == 'cerfa14023'
                    "
                    show
                    variant="info"
                    class="no-margin-bottom mt-3"
                  >
                    Vous n’avez pas besoin de permission de voirie,
                    veuillez-vous reporter au menu « Autorisation de circulation
                    »
                  </b-alert>
                </ValidationProvider>
                <!-- <b-form-input
                  v-model="natureWorkOther"
                  class="form-control send-api"
                  placeholder="Décrivez en quelques mots"
                /> -->
              </b-col>
              <!-- <b-col xl="10" lg="9" md="9" sm="12" cols="12">
                              <b-form-input v-model="natureWorkOther" class="form-control send-api" placeholder="Décrivez en quelques mots" />
                          </b-col> -->
              <!-- <b-col lg="12" md="12" sm="12" cols="12" class="text-center">
                              <b-form-radio-group v-model="cerfa.natureWork" :options="works"></b-form-radio-group>
                          </b-col> -->
            </b-row>
          </div>
          <div class="form-group">
            <b-row>
              <b-col xl="3" lg="3" md="3" sm="12" cols="12" class="no-padding">
                <label class="control-label"
                  >Quel est le type de votre demande ?
                  <span class="red">*</span></label
                >
              </b-col>
              <b-col xl="9" lg="9" md="9" sm="12" cols="12">
                <ul class="lst-choix">
                  <li
                    class="col-xl-6 col-lg-6 col-md-12 col-sm12 col-xs-12"
                    @click="choiceCerfa('cerfa14023')"
                  >
                    <div
                      id="choix-11"
                      :class="
                        dossierSelected.type.includes('cerfa14023')
                          ? 'valid-sous-type selected'
                          : ''
                      "
                    >
                      <!-- classe selected à virer par la suite, c'est juste pour savoir où la mettre -->
                      <b>Permission de voirie</b>
                      <span> 14023*01</span>
                    </div>
                  </li>
                  <li
                    class="col-xl-6 col-lg-6 col-md-12 col-sm12 col-xs-12"
                    @click="choiceCerfa('cerfa14024')"
                  >
                    <div
                      id="choix-9"
                      :class="
                        dossierSelected.type.includes('cerfa14024')
                          ? 'valid-sous-type selected'
                          : ''
                      "
                    >
                      Arrêté de circulation
                      <span>14024*01</span>
                    </div>
                  </li>
                </ul>
                <!-- <div class="error" id="error-type_demande">
              Cette information est obligatoire, merci de sélectionner un type
              de demande.
            </div> -->
              </b-col>
            </b-row>
            <div
              class="container-cerfa"
              v-if="request.type.includes('cerfa14023')"
            >
              <div class="title-cerfa">Permission de voirie 14023*01</div>
              <b-row>
                <b-col lg="12" md="12" sm="12" cols="12">
                  <d14023-nature-travaux></d14023-nature-travaux>
                  <d14023-custome-form></d14023-custome-form>
                </b-col>
              </b-row>
            </div>
            <div
              class="container-cerfa"
              v-if="request.type.includes('cerfa14024')"
            >
              <div class="title-cerfa">Arrêté de circulation 14024*01</div>
              <b-row>
                <b-col lg="12" md="12" sm="12" cols="12">
                  <d14024-nature-travaux></d14024-nature-travaux>
                  <d14024-reglementation></d14024-reglementation>
                  <d14024-signalisation></d14024-signalisation>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>

        <div class="stepper-control">
          <b-button
            variant="white"
            @click="previous"
            class="btn marginRight-10 marginBottom-15"
          >
            <font-awesome-icon
              icon="caret-left"
              class="marginRight-5"
            ></font-awesome-icon>
            Précédent
          </b-button>
          <b-button type="submit" variant="primary" class="marginBottom-15">
            <span>Suivant</span>
            <font-awesome-icon
              icon="caret-right"
              class="marginLeft-5"
            ></font-awesome-icon>
          </b-button>
        </div>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import Vuex from "vuex";
import Vue from "vue";
import D14023NatureTravaux from "./D14023/NatureTravaux.vue";
import D14023CustomeForm from "./D14023/CustomeForm.vue";
import D14024NatureTravaux from "./D14024/NatureTravaux.vue";
import D14024Reglementation from "./D14024/Reglementation.vue";
import D14024Signalisation from "./D14024/Signalisation.vue";

export default {
  props: ["value", "demandeurInfo"],
  name: "ChoixCerfa",
  components: {
    "d14023-custome-form": D14023CustomeForm,
    "d14023-nature-travaux": D14023NatureTravaux,
    "d14024-nature-travaux": D14024NatureTravaux,
    "d14024-reglementation": D14024Reglementation,
    "d14024-signalisation": D14024Signalisation,
  },
  data: () => ({
    natureWorkOther: null,
    naturesTvx: [
      {
        text: "Création/Suppression d’infrastructures souterraines",
        value: "Création/Suppression d’infrastructures souterraines",
      },
      {
        text: "Création/Suppression d’infrastructures aériennes ",
        value: "Création/Suppression d’infrastructures aériennes ",
      },
      {
        text: "Pose/Dépose d’armoire ou Shelter",
        value: "Pose/Dépose d’armoire ou Shelter",
      },
      {
        text: "Réparation d’infrastructures existantes",
        value: "Réparation d’infrastructures existantes",
      },
      { text: "Travaux de câblage", value: "Travaux de câblage" },
    ],
  }),
  mounted() {
    this.$nextTick(function () {});
  },
  methods: {
    ...Vuex.mapActions("Cerfa", [
      "addCerfa14023",
      "addCerfa14024",
      "initCerfa14024",
      "initCerfa14023",
      "setCerfa14024",
      "setCerfa14023",
      "updateCerfa14023",
      "updateCerfa14024",
    ]),
    ...Vuex.mapActions("Dossiers", ["setDossier"]),
    // ...Vuex.mapActions("Cerfa", ["setCerfa14023"]),
    // ...Vuex.mapActions("Cerfa", ["setCerfa14024"]),
    changeNature() {
      if (this.natureWorkOther == "Travaux de câblage") {
        this.dossierSelected.type = ["cerfa14024"];
        return;
      } else if (this.natureWorkOther == "Pose/Dépose d’armoire ou Shelter") {
        this.cerfa1402301.networkConnectionOther =
          "Pose/Dépose d’armoire ou Shelter";
        let arr = [];
        if (this.cerfa1402301.networkConnection != null) {
          arr = this.cerfa1402301.networkConnection.split(",");
        }
        if (arr.indexOf("autre") != -1) return;
        arr.push("autre");
        this.cerfa1402301.networkConnection = arr.join(",");
      } else {
        this.cerfa1402301.networkConnectionOther = "Télécommunication";
        let arr = [];
        if (this.cerfa1402301.networkConnection != null) {
          arr = this.cerfa1402301.networkConnection.split(",");
        }
        if (arr.indexOf("autre") != -1) return;
        arr.push("autre");
        this.cerfa1402301.networkConnection = arr.join(",");
      }
    },
    previous() {
      this.$emit("previous");
    },
    send() {
      this.$refs.formObserver.validate().then((success) => {
        if (success == true) {
          if (this.request.type.length > 0) {
            this.$emit("submit");
          } else {
            this.$emit("error", "Veuillez Choisir un cerfa");
          }
        } else {
          this.$emit("error", "Veuillez corriger les erreurs du formulaire");
        }
      });
    },
    choiceCerfa(type) {
      if (this.natureWorkOther != "Travaux de câblage") {
        if (this.request.type.includes(type)) {
          let index = this.request.type.indexOf(type);
          if (index > -1) {
            this.request.type.splice(index, 1);
          }
        } else {
          this.request.type.push(type);
        }
        if (
          this.request.type.includes("cerfa14023") &&
          this.cerfa14023 == null
        ) {
          this.initCerfa14023();
        }
        if (
          this.request.type.includes("cerfa14024") &&
          this.cerfa14024 == null
        ) {
          this.initCerfa14024();
        }
      }
    },
  },
  computed: {
    request: {
      get: function () {
        return this.dossierSelected;
      },
      set: function (newValue) {
        this.setDossier(newValue);
      },
    },

    cerfa1402401: {
      get: function () {
        return this.cerfa14024;
      },
      set: function (newValue) {
        this.setCerfa14024(newValue);
      },
    },
    cerfa1402301: {
      get: function () {
        return this.cerfa14023;
      },
      set: function (newValue) {
        this.setCerfa14023(newValue);
      },
    },
    ...Vuex.mapGetters("Cerfa", ["cerfa14023"]),
    ...Vuex.mapGetters("Cerfa", ["cerfa14024"]),
    ...Vuex.mapGetters("Dossiers", ["dossierSelected"]),
  },
};
</script>

<style scoped></style>
